export const CORPORATE_ENROLLMENT_QUERY_KEY = ['corporate-enrollment']
